module.exports = __webpack_public_path__ + "static/media/ember.5ed9604c.svg";